document.addEventListener('DOMContentLoaded', () => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  document.querySelectorAll('.sticky-atc').forEach((bar) => {
    const target = document.getElementById(bar.dataset.observeTarget);
    const submitButton = document.getElementById(bar.dataset.submitId);
    const stickyButton = bar.querySelector('.sticky-atc__button');

    if (!target || !submitButton || !stickyButton) return;

    stickyButton.addEventListener('click', () => {
      submitButton.click();
    });

    if (typeof subscribe === 'function') {
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        const nextBar = data.html.getElementById(bar.id);
        if (!nextBar) return;

        bar.querySelector('.sticky-atc__price').innerHTML = nextBar.querySelector('.sticky-atc__price').innerHTML;
        const nextButton = nextBar.querySelector('.sticky-atc__button');
        stickyButton.textContent = nextButton.textContent;
        stickyButton.disabled = nextButton.disabled;
      });
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          bar.hidden = !mobileQuery.matches || entry.isIntersecting;
        });
      },
      { threshold: 0 }
    );

    observer.observe(target);

    mobileQuery.addEventListener('change', () => {
      if (!mobileQuery.matches) bar.hidden = true;
    });
  });
});
